import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import React, { useState } from "react";
import "../../css/alarm/ManageAlarmSeeMoreAdd.css";
import "../../css/Manage.css";
import AlarmApi from "../../api/alarmApi";
import { toast } from "react-toastify";

const ManageResidencyNotification = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const {state} = useLocation()

  const alarmAddHandler = async () => {
    AlarmApi.Selected({
      alarm:{
        title,
        content,
      },
      residencyIds: state.tel.map(v=>v.residencyId),
    })
      .then(() => {
        toast("등록되었습니다.");
        navigate("/admin/alarm/1");
      })
      .catch(() => toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요."));
  };

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-general-member-adit">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-alarm-see-more-add">
          <span>거주권 알림전송</span>
          <div className="Manage-input-container">
            <p className="Manage-input-title">제목</p>
            <input
              className="Manage-input-textarea manage-form-alarm-see-more-input"
              type="text"
              value={title}
              placeholder="제목을 입력하세요"
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div>
          <div className="Manage-input-container Manage-input-container-maintext">
            <p className="Manage-input-title">내용</p>
            <textarea
              value={content}
              className="Manage-input-textarea manage-form-alarm-see-more-textarea"
              onChange={(e) => {
                setContent(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="Manage-form-save manage-form-save-alarm-see-more-add">
            <button onClick={alarmAddHandler} className="cursorPointer">
              등록하기
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageResidencyNotification;
